const ES = {
    title: 'Correos',
    actions: 'Modificar correo',
    table: {
        title: 'Correos',
        columns: {
            id: 'Id',
            email: 'Correo',
            created_at: 'Fecha alta',
            updated_at: 'Fecha modificación',
            status: 'Estado',
        },
        status: {
            3: 'Activo',
            2: 'Inactivo',
            title: 'Estado'
        },
    },
    inputs: {
        modify: 'Nuevo correo',
        placeholder: 'Ingresá un nuevo correo',
    },
    alert: {
        info: {
            title: 'Enviamos un correo a ',
            description: 'El cliente tiene 24hs. para ingresar y hacer la verificación que allí se solicita'
        },
        warning: {
            title1: 'El correo ',
            title2: ' no está disponible para ser usado por este cliente',
            description: 'Solicite otro correo'
        }
    }
};

export default ES;
